export const ProductComparison = "7f48c5f8c0cf5bb63c4864e7744cf732d0abdfadb7b97e23d6d4bd32abb6d3d0";